<div class="auth-refund">
  <div class="refund-text">{{'refundAmount' | translate}}: {{OperationCurrency}}{{data.FinancialData.PaymentAmount | currencyDecimalFormatter}}
  </div>
  @if (message) {
    <div [ngStyle]="{'background':'red'}" class="message-view">
      <span class="message-view__text">{{message | translate}}</span>
      <span class="message-view__close icon-close" (click)="closeMessage()"></span>
    </div>
  }
  <div class="refund-popup" [ngClass]="{'refund-popup-error': message}">
    @for (option of refundOptions; track option; let index = $index) {
      <div class="card">
        <div class="card__type">
          <mat-checkbox class="card__type__checkbox" [(ngModel)]="option.checked"
            (change)="selectType($event.checked, index )">
            @if (option.data.PaymentType == AuthorizePaymentTypes.Payment_Only) {
              <span class="card__type__name"
                >{{'creditCard' |
              translate}}</span>
            }
            @if (option.data.PaymentType == AuthorizePaymentTypes.Post_To_RoomCharge) {
              <span class="card__type__name"
                >{{'roomCharge'
                |
              translate}}</span>
            }
            @if (option.data.PaymentType == AuthorizePaymentTypes.Loyalty_Point) {
              <span class="card__type__name"
                >{{'loyaltyPoints' |
              translate}}</span>
            }
          </mat-checkbox>
        </div>
        @if (option.data.PaymentType == AuthorizePaymentTypes.Payment_Only) {
          <div class="card__field">
            <div class="card__field-label">{{'cardNumber' | translate}}</div>
            <div class="card__field-value">{{option.data.MaskedCardNumber}}</div>
          </div>
        }
        @if (option.data.PaymentType == AuthorizePaymentTypes.Post_To_RoomCharge) {
          <div class="card__field">
            <div class="card__field-label">{{'roomNumber' | translate}}</div>
            <div class="card__field-value">{{(option.data.RoomNumber || 'NA') | translate}}</div>
          </div>
        }
        @if (option.data.PaymentType == AuthorizePaymentTypes.Loyalty_Point) {
          <div class="card__field">
            <div class="card__field-label">{{'bucketName' | translate}}</div>
            <div class="card__field-value">{{(option.data.BucketName || 'NA') | translate}}</div>
          </div>
        }
        <div class="card__field">
          <div class="card__field-label">{{'chargedOn' | translate}}</div>
          <div class="card__field-value">{{option.data.TransactionDate | formatSettingsDate: ps.restaurantWidgetSettings$.value.DateFormat}}</div>
        </div>
        <div class="card__field">
          <div class="card__field-label">{{'amountPaid' | translate}}</div>
          <div class="card__field-value">{{option.data.PaymentAmount}}</div>
        </div>
        <div class="card__field">
          <div class="card__field-label">{{'MembershipID' | translate}}</div>
          <div class="card__field-value">{{(data.memberShipId || 'NA') | translate}}</div>
        </div>
        <div class="card__field card__field__amount">
          <label class="card__field__seat-labels" for="">{{'refundAmount' | translate}}</label>
          <dynamic-form [config]="option.refundAmountConfig" #form="dynamicForm">
          </dynamic-form>
        </div>
      </div>
    }
  </div>
</div>